
import home from '../views/home.vue'
import notfound from '../views/notfound.vue'
import graph from '../components/components/graph.vue'
import oddsanalysis from '../views/oddsanalysis.vue'
import languagevarianthtml from '../components/components/languagevarianthtml.vue'


export default [
    
    {path: '/',component: home,name: 'home'},
    {path: '/login',component:() => import('../views/login.vue'), name: 'login'},
    {path: '/Horses-Mouth/:param1(.*)*',component:() => import('../views/fullpagehorsesmouth.vue') ,name: 'fullpagehorsesmouth',props: true},
    {path: '/Knowledgebase',component:() => import('../views/knowledgebase.vue') ,name: 'knowledgebase',props: false},
    {path: '/Sport/:sport/:opencountry', component: () => import('../views/sport.vue'), name: 'sport', props:true},
    {path: '/Competition/:sport/:eventparams?', component: () => import('../views/events.vue'), name: 'events', props:true},
    {path: '/Event/:sport/:country/:competition/:competitors/:bettype', component: () => import('../views/eventodds.vue'), name: 'eventodds', props:true},
    {path: '/Search/:searchdesc', component: () => import('../components/navigation/searchresults.vue') , name: 'searchresults', props:true},
   
    {path: '/Calculators/Hutch-Dutch', component:() => import('../components/features/hutchdutchcalc.vue'), name: 'hutchdutchcalc', props:true},
    {path: '/Past-Bets/:startdate?/:user?', component: graph, name: 'graph', props:true},
    {path: '/Kit-Viewer', component: () => import('../views/kitviewer.vue'), name: 'kitviewer', props:true},
    {path: '/Calculators/GameResults', component: () => import ('../components/features/hutchdutchgameresults.vue') , name: 'hutchdutchgameresults', props:true},
    {path: '/Offers/:param1(.*)*', component:() => import('../components/adverts/offers.vue'), name: 'offers', props:true},

    {path: '/Calculators/Bet-Results', component: () => import( '../components/features/hutchdutchsettlement.vue') , name: 'hutchdutchbetsettlement', props:true},
    {path: '/Calculators/Pending-Bets', component: () => import( '../components/features/hutchdutchsettlement.vue') , name: 'pendingbets', props:true},

    {path: '/Outright/:sport/:compdesc', component: () => import('../views/outrightodds.vue'), name: 'outrightodds', props:true},  
    {path: '/Odds-Analysis', component: oddsanalysis, name: 'oddsanalysis', props:false}, 

    {path: '/About-Site', component: languagevarianthtml, name: 'aboutsite', props:true},
    
    {path: '/License-Settings', component:() => import('../components/components/licensesettings.vue'), name: 'licensesettings'},
    {path: '/Booker-Settings', component:() => import('../components/components/bookmakersettings.vue') , name: 'bookmakersettings', props:true},
    {path: '/Timezone', component:() => import('../components/components/timezone.vue'), name: 'timezone', props:true},
    {path: '/Exchange-Settings', component:() => import('../components/components/exchangesettings.vue'), name: 'exchangesettings', props:true},
    {path: '/FeedBack', component:() => import('../components/components/feedback.vue'), name: 'feedback', props:true},

    {path: '/Terms-and-Conditions', component:() => import('../components/components/HtmlWrapper.vue'), props: {htmlFile: require('../assets/articles/termsandconditions.html')} , name: 'termsandconditions'},
    {path: '/Bookmaker-Comparison', component:() => import('../views/bookmakercomparison.vue'), name: 'bookmakercomparison'},
    {path: '/Cookie-Policy', component:  () => import( '../components/components/HtmlWrapper.vue'), props: {htmlFile: require('../assets/articles/cookiepolicy.html')} , name: 'cookiepolicy'},
    {path: '/Privacy-Policy', component: () => import('../components/components/HtmlWrapper.vue'), props: {htmlFile: require('../assets/articles/privacypolicy.html')} , name: 'privacypolicy'},
    
    {path: '/Betfinder', component:() => import('../components/features/betfinder.vue'), name: 'betfinder', props:true},
    
    
    
    
    
    { path: '*', component: notfound, name: 'notfound' }


    
]
